// state.js
export default {
    customers: [],
    filtersChanged: false,
}
